var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DropdownMenuComponent_1;
import { css, html, render as litRender, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { GGOBaseComponent } from '../ggo.base.component.js';
import { ButtonComponent } from '../button/button.component.js';
let DropdownMenuComponent = class DropdownMenuComponent extends GGOBaseComponent {
    constructor() {
        super(...arguments);
        this.items = [];
        this.icon = '';
        this.title = '';
        this.buttonLabel = '';
        this.menuDirection = DropdownMenuComponent_1.RIGHT;
        this.open = false;
        this.menuElement = null;
    }
    static { DropdownMenuComponent_1 = this; }
    static { this.LEFT = 'slds-dropdown slds-dropdown_left'; }
    static { this.RIGHT = 'slds-dropdown slds-dropdown_right'; }
    static { this.DOWN = 'slds-dropdown slds-dropdown_bottom'; }
    static { this.DOWN_RIGHT = 'slds-dropdown slds-dropdown_bottom slds-dropdown_right'; }
    static { this.DOWN_LEFT = 'slds-dropdown slds-dropdown_bottom slds-dropdown_left'; }
    static get styles() {
        return [
            ...super.styles,
            css `
        .square_button {
          display: flex;
          flex-direction: row-reverse;
          height: 1.5rem;
          width: 1.5rem;
        }
        .slds-button:active.square_button {
          border-color: #1b96ff;
        }
        .slds-dropdown-trigger {
          background: #fff;
          border-radius: .25rem;
          border: solid 1px #C9C9C9;
        }
        .slds-dropdown-trigger:hover {
          border: solid 1px #1b96ff;
          box-shadow:rgba(0, 0, 0, 0.15) 1px 1px 2px;
        }
        .slds-dropdown-trigger>.slds-dropdown.slds-dropdown_right {
          margin-right: -1px;
        }
        li>a:hover {
          color: #1b96ff;
        }
      `,
        ];
    }
    render() {
        // Only render the button in the Lit tree
        return html `
      <div class="slds-dropdown-trigger slds-dropdown-trigger_click">
        <ggo-button
          variant="${ButtonComponent.ICON}"
          title="${this.title}"
          aria-haspopup="true"
          aria-expanded="${this.open ? 'true' : 'false'}"
          @click="${this.toggleMenu}"
          icon="${this.icon}"
        >
          <span class="slds-assistive-text">${this.title || 'Show More'}</span>
        </ggo-button>
      </div>
    `;
    }
    toggleMenu(e) {
        e.stopPropagation();
        this.open = !this.open;
        const onScroll = () => {
            this.open = false;
            this.menuElement?.remove();
            this.menuElement = null;
            window.removeEventListener('scroll', onScroll, true);
        };
        if (this.open) {
            // Create menu in body
            this.menuElement = document.createElement('div');
            this.menuElement.className = "slds-dropdown";
            this.menuElement.style.position = 'absolute';
            this.menuElement.style.zIndex = '10000';
            // Position it below the button by default
            const rect = e.target.getBoundingClientRect();
            // Render the menu to measure its height
            litRender(html `
          <ul class="slds-dropdown__list" role="menu" aria-label="${this.title || 'Show More'}">
            ${this.items.map((item, idx) => html `
              <li class="slds-dropdown__item" role="presentation">
                <a href="#" role="menuitem" tabindex="${idx === 0 ? 0 : -1}" @click="${(ev) => this.handleItemClick(ev, item)}">
                  <span class="slds-truncate" title="${item.title ?? item.text}">
                    ${item.icon ? html `<ggo-icon icon="${item.icon}" size="xsmall" style="margin-right:0.5rem"></ggo-icon>` : nothing}
                    ${item.text}
                  </span>
                </a>
              </li>
              ${item.dividerAfter ? html `<li class="slds-has-divider_top-space" role="separator"></li>` : nothing}
            `)}
          </ul>
        `, this.menuElement);
            document.body.appendChild(this.menuElement);
            // Now measure the menu height
            const menuRect = this.menuElement.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            const spaceAbove = rect.top;
            if (menuRect.height > spaceBelow && spaceAbove > spaceBelow) {
                // Not enough space below, but enough above: show above
                this.menuElement.style.left = `${rect.left}px`;
                this.menuElement.style.top = `${rect.top - menuRect.height}px`;
            }
            else {
                // Default: show below
                this.menuElement.style.left = `${rect.left}px`;
                this.menuElement.style.top = `${rect.bottom}px`;
            }
            this.menuElement.className = "slds-dropdown";
            window.addEventListener('scroll', onScroll, true);
            // Remove scroll listener when menu closes
            const onClickOutside = (event) => {
                if (!this.menuElement?.contains(event.target)) {
                    this.open = false;
                    this.menuElement?.remove();
                    this.menuElement = null;
                    document.removeEventListener('mousedown', onClickOutside);
                    window.removeEventListener('scroll', onScroll, true);
                }
            };
            setTimeout(() => {
                document.addEventListener('mousedown', onClickOutside);
            }, 0);
        }
        else {
            this.menuElement?.remove();
            this.menuElement = null;
            window.removeEventListener('scroll', onScroll, true);
        }
    }
    handleItemClick(e, item) {
        e.preventDefault();
        e.stopPropagation();
        this.dispatchEvent(new CustomEvent('click', {
            detail: { ...item, elementId: this.getAttribute('id') },
        }));
        this.open = false;
        this.menuElement?.remove();
        this.menuElement = null;
    }
};
__decorate([
    property({ type: Array })
], DropdownMenuComponent.prototype, "items", void 0);
__decorate([
    property({ type: String })
], DropdownMenuComponent.prototype, "icon", void 0);
__decorate([
    property({ type: String })
], DropdownMenuComponent.prototype, "title", void 0);
__decorate([
    property({ type: String })
], DropdownMenuComponent.prototype, "buttonLabel", void 0);
__decorate([
    property({ type: String })
], DropdownMenuComponent.prototype, "menuDirection", void 0);
__decorate([
    state()
], DropdownMenuComponent.prototype, "open", void 0);
DropdownMenuComponent = DropdownMenuComponent_1 = __decorate([
    customElement('ggo-dropdown')
], DropdownMenuComponent);
export { DropdownMenuComponent };
